// Ícones da organização (desenho próprio, mesmo traço dos de Icons.tsx). Decorativos: o nome fica no botão.
const S = (d: string, w = 1.75) => () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width={w} stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d={d} />
  </svg>
);
export const IconPin = S("M9 3.5h6M10 3.5v5.5l-3.5 4h11L14 9V3.5M12 13v7.5");
export const IconLock = S("M7.5 11V8a4.5 4.5 0 0 1 9 0v3M5.5 11h13v9.5h-13zM12 15v2");
export const IconPencil = S("M4 20l1-4.5L15.5 5a2.1 2.1 0 0 1 3 3L8 18.5zM13.5 7l3 3");
export const IconTag = S("M3.5 3.5h7.5l9.5 9.5-7.5 7.5-9.5-9.5zM8 8h.01", 2);
export const IconSelect = S("M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18zM8 12.3l2.8 2.8L16.2 9.5");
export const IconCheckSmall = S("M5.5 12.5l4 4 9-9.5", 2.75);
export const IconSort = S("M8 19V5M4.5 8.5L8 5l3.5 3.5M16 5v14M12.5 15.5L16 19l3.5-3.5");
export const IconMerge = S("M6 3.5v4a6 6 0 0 0 6 6 6 6 0 0 1 6 6v1M18 3.5v4a6 6 0 0 1-3.5 5.4M9 17.5l-3 3-3-3");
export const IconRingPlus = S("M12 4a8 8 0 1 0 8 8M18.5 2.5v6M15.5 5.5h6");
/** Três anéis entrelaçados: marca das coleções nos diálogos. */
export const RingsMark = () => (
  <svg viewBox="0 0 48 48" fill="none" stroke-width="2.5" aria-hidden="true">
    <circle cx="18" cy="19" r="10" stroke="var(--accent)" />
    <circle cx="30" cy="19" r="10" stroke="var(--success)" />
    <circle cx="24" cy="29" r="10" stroke="var(--tone-3)" />
  </svg>
);
